const root = 'MarketplaceToolbar'

export const TestId = {
  filtersButton: `${root}-filtersButton`,
  orderingSelect: `${root}-orderingSelect`,
  orderingSelectOption: `${root}-orderingSelect-option`,
}
